/* globals Drupal */

import React, { useGlobal } from 'reactn';

const RoomNumberInput = ({ fetchResults }) => {
    const [booking, setBooking] = useGlobal('booking');
    const [isConfirming, setConfirming] = useGlobal('confirming');
    const [roomNumber, setRoomNumber] = useGlobal('roomNumber');
    const [, setError] = useGlobal('error');
    const [isLoading] = useGlobal('loading');

    const onNext = async () => {
        if (roomNumber.length < 4) {
            return;
        }

        fetchResults(roomNumber.join(''));
    };

    const onPrevious = async () => {
        setConfirming(false);
        setBooking(null);
        setError(null);
        setRoomNumber([]);
    };

    const onFinish = async () => {
        try {
            const response = await fetch(`/api/package/${booking.id}/confirm`, { method: 'POST' });

            if (!response.ok) {
                // TODO: Show modal
                throw new Error('Server returned an invalid response.');
            }

            window.location = '/';
        } catch (e) {
            console.error(e.message);
        }
    };

    if (isConfirming) {
        return (
            <>
                <h2 className="heading-1">{Drupal.t('Please confirm.')}</h2>
                <div className="room-number-input">
                    <span className="room-number-input__number">{roomNumber[0]}</span>
                    <span className="room-number-input__number">{roomNumber[1]}</span>
                    <span className="room-number-input__number">{roomNumber[2]}</span>
                    <span className="room-number-input__number">{roomNumber[3]}</span>
                </div>
                <div className="buttons">
                    <button className="button button--normal button--dark-bg" onClick={onPrevious}>
                        {Drupal.t('Back')}
                    </button>
                    <button className="button button--normal button--dark-bg" onClick={onFinish} disabled={!booking}>
                        {Drupal.t('Finish')}
                    </button>
                </div>
            </>
        );
    }

    return (
        <>
            <h2 className="heading-1">{Drupal.t("What's the room number?")}</h2>
            <div className="room-number-input">
                <span className="room-number-input__number is-editing">{roomNumber[0]}</span>
                <span className="room-number-input__number is-editing">{roomNumber[1]}</span>
                <span className="room-number-input__number is-editing">{roomNumber[2]}</span>
                <span className="room-number-input__number is-editing">{roomNumber[3]}</span>
            </div>
            <div className="buttons">
                <button
                    className="button button--normal button--dark-bg"
                    onClick={onNext}
                    disabled={isLoading || roomNumber.length !== 4}
                >
                    {Drupal.t('Next')}
                </button>
            </div>
        </>
    );
};

export default RoomNumberInput;
